import { render, staticRenderFns } from "./CompareRulesModal.vue?vue&type=template&id=0f730d83"
import script from "./CompareRulesModal.vue?vue&type=script&lang=js"
export * from "./CompareRulesModal.vue?vue&type=script&lang=js"
import style0 from "./CompareRulesModal.vue?vue&type=style&index=0&id=0f730d83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports